// DownloadButton.jsx
import React, { useState } from "react";
import api from "../../services/api";

export default function DownloadButton({
  endpoint,
  buttonLabel,
  defaultFileName,
  method = "post",
  requestBody = null,
  className = "btn btn-outline-success",
  onError,
}) {
  const [progress, setProgress] = useState(null);

  const download = async (e) => {
    if (e) e.stopPropagation();
    setProgress(0);

    try {
      const response = await api.request({
        url: endpoint,
        method,
        data: requestBody,
        responseType: "blob",
        onDownloadProgress: (evt) => {
          if (evt.total) {
            setProgress(Math.round((evt.loaded / evt.total) * 100));
          } else if (evt.loaded) {
            // если total неизвестен — показываем «ползущий» прогресс
            setProgress((p) => (p < 90 ? p + 5 : p));
          }
        },
      });

      setProgress(100);

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const cd = response.headers["content-disposition"];
      let fileName = defaultFileName;
      if (cd) {
        const utf8Match = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
        const asciiMatch = cd.match(/filename\s*=\s*["']?([^;"']+)["']?/i);
        if (utf8Match && utf8Match[1]) {
          try {
            fileName = decodeURIComponent(utf8Match[1]);
          } catch {
            fileName = utf8Match[1];
          }
        } else if (asciiMatch && asciiMatch[1]) {
          fileName = asciiMatch[1];
        }
      }

      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Ошибка скачивания:", err);
      if (onError) onError(err);
    } finally {
      // небольшая задержка, чтобы пользователь увидел 100%
      setTimeout(() => setProgress(null), 600);
    }
  };

  return (
    <div>
      <button
        className={className}
        onClick={download}
        disabled={progress !== null && progress < 100}
      >
        {buttonLabel}
      </button>

      {progress !== null && (
        <div className="progress mt-2" style={{ height: "8px" }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100"
          />
        </div>
      )}
    </div>
  );
}